import { Box, Container } from "@mui/material";
import { useRecoilState } from "recoil";
import { ThemeLight } from "../../state/ThemeLight";

export const ContactUs = () => {
  const [themeLight] = useRecoilState(ThemeLight);

  return (
    <>
      <Container className="container-xxl">
        <Box className="row justify-content-center text-center mt-6">
          <Box className="col-sm-10 col-lg-8 col-xl-6">
            <h2 className="h4">Contact Us</h2>
            <p className="fs-base">
              If you have any questions on the UPCX BlockExplorer APIs, ask them
              here!
            </p>
          </Box>
        </Box>
        <Box className="row justify-content-center">
          <Box className="col-lg-8">
            <Box className="card bg-light shadow-none p-6">
              <div className="alert alert-info mb-0">
                <img
                  className="img-fluid mx-auto"
                  src={
                    themeLight
                      ? "/assets/img/contactus_light.png"
                      : "/assets/img/contactus_dark.png"
                  }
                  alt=""
                />
              </div>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};
